/**
 * Cookie consent banner.
 *
 * UK GDPR / PECR require consent *before* analytics cookies are set, and
 * refusing has to be as easy as accepting — so both buttons carry equal weight
 * and neither is pre-selected. Analytics stay denied until "Accept" is pressed.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CookieConsent.css';
import { getStoredConsent, setAnalyticsConsent } from '../lib/analytics';

function CookieConsent() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only ask people who haven't answered yet.
    if (!getStoredConsent()) {
      // Small delay so the banner doesn't fight the page for attention on load.
      const id = window.setTimeout(() => setVisible(true), 900);
      return () => window.clearTimeout(id);
    }
    return undefined;
  }, []);

  const decide = (granted) => {
    setAnalyticsConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookieConsent" role="dialog" aria-live="polite" aria-label="Cookie choices">
      <div className="cookieConsentBody">
        <p className="cookieConsentTitle">A quick word about cookies</p>
        <p className="cookieConsentText">
          We'd like to use analytics cookies to understand how people use our shop, so we can make it
          better. They're optional — the site works either way, and we never sell your data.{' '}
          <button
            type="button"
            className="cookieConsentLink"
            onClick={() => navigate('/privacy')}
          >
            Read our privacy policy
          </button>
        </p>
      </div>

      <div className="cookieConsentActions">
        <button type="button" className="cookieConsentBtn cookieConsentBtn--ghost" onClick={() => decide(false)}>
          Decline
        </button>
        <button type="button" className="cookieConsentBtn cookieConsentBtn--solid" onClick={() => decide(true)}>
          Accept
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
